import axiosInstance, { CustomAxiosRequestConfig } from "../services/axios";
import { IProperties } from "../types";
import { IListings } from "../types/listing";
import { Endpoints } from "./endpoint";
import { QueryObject } from "./global";


export const createListingsApi=async(payload:Partial<IListings>)=>{
    const res = await axiosInstance.post(
        `${process.env.NEXT_PUBLIC_API}${Endpoints.LISTINGS.CREATE}`,
        payload,
        {
            requiresAuth: true // Custom property to skip auth
        } as CustomAxiosRequestConfig
    );
    return res.data;
}

export const getListingsApi=async(payload:Partial<QueryObject<{propertyName:string,location:string,price:string,listingStatus:string,sort:string,status:string}>>)=>{
    

    let url = `${process.env.NEXT_PUBLIC_API}${Endpoints.LISTINGS.CREATE}`;
    const queryParams = [];
  
    if (payload.page !== undefined) {
      queryParams.push(`page=${payload.page}`);
    }
    if(payload.location !== undefined && payload.location !==""){
      queryParams.push(`location=${payload.location}`); 
    }
     if(payload.price !== undefined && payload.price !==""){
      queryParams.push(`price=${payload.price}`); 
    }
      if(payload.listingStatus !== undefined && payload.listingStatus !==""){
      queryParams.push(`listingStatus=${payload.listingStatus.toLowerCase()}`); 
    }
    if(payload.status !== undefined && payload.status !==""){
      queryParams.push(`status=${payload.status.toLowerCase()}`); 
    }
 if(payload.sort !== undefined && payload.sort !==""){
      queryParams.push(`sort=${payload.sort}`); 
    }
    if (payload.limit !== undefined) {
      queryParams.push(`limit=${payload.limit}`);
    }
     if(payload.propertyType!==undefined&&payload.propertyType!==""){
      queryParams.push(`propertyType=${payload.propertyType}`);
    }
    if(payload.propertyName !==undefined){
      queryParams.push(`propertyName=${payload.propertyName}`);
    }
  //  queryParams.push(`populate=floorplan,documents,property,property.media,property.documents`);
    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }
  
    const res = await axiosInstance.get(url);
    return res.data;
}

export const updateListingApi=async(payload:Partial<IProperties>)=>{
  const {_id,...data}=payload;
  const res = await axiosInstance.put(
      `${process.env.NEXT_PUBLIC_API}${Endpoints.LISTINGS.CREATE}/${_id}`,
      data,
      {
          requiresAuth: true // Custom property to skip auth
      } as CustomAxiosRequestConfig
  );
  return res.data;
}
export const getListingApi=async(id:string)=>{
  if(!id) return null;
  const res = await axiosInstance.get(
      `${process.env.NEXT_PUBLIC_API}${Endpoints.LISTINGS.CREATE}/${id}`,
      {
          requiresAuth: false // Custom property to skip auth
      } as CustomAxiosRequestConfig
  );
  return res.data;
}

export const removeListingApi=async(id:string)=>{
  if(!id) return null;
  const res = await axiosInstance.delete(
      `${process.env.NEXT_PUBLIC_API}${Endpoints.LISTINGS.CREATE}/${id}`,
      {
          requiresAuth: true // Custom property to skip auth
      } as CustomAxiosRequestConfig
  );
  return res.data;
}